"use strict";

exports.__esModule = true;
exports.default = void 0;
var _copyObject = _interopRequireDefault(require("./_copyObject.js"));
var _keysIn = _interopRequireDefault(require("./keysIn.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && (0, _copyObject.default)(source, (0, _keysIn.default)(source), object);
}
var _default = exports.default = baseAssignIn;